<script lang="ts">
  import { Col, Image, Row } from "sveltestrap";
  export let elem;
</script>
  
<div class="media align-self-center">
  <Image
    class="align-self-center"
    src={elem.src}
    alt="Generic placeholder image"
  />
  <div class="media-body">
    <Row>
      <Col md="4">
        <h6 class="mt-0">{elem.name}<span> ( {elem.post} )</span></h6>
      </Col>
      <Col md="8">
        <ul class="comment-social">
          <li>
            <i class="icofont icofont-thumbs-up" />{elem.hits}
          </li>
          <li>
            <i class="icofont icofont-ui-chat" />{elem.comments}
          </li>
        </ul>
      </Col>
    </Row>
    <p>{elem.para}</p>
  </div>
</div>
  